export default __webpack_public_path__ + "static/media/asset_kontributor_right.60a824e0.png";